// import React, { useState, useEffect, useRef } from 'react';
// import {
// 	TextField,
// 	Button,
// 	Switch,
// 	FormControlLabel,
// 	Container,
// 	Box,
// 	Dialog,
// 	DialogTitle,
// 	DialogContent,
// 	DialogActions,
// 	IconButton,
// 	Typography,
// } from '@mui/material';
// import { toast } from 'react-toastify';
// import ReactQuill from 'react-quill';
// import 'react-quill/dist/quill.snow.css';
// import CloseIcon from '@mui/icons-material/Close';
// import { ServiceProduct } from 'types/serviceProduct';
// import { getSingleProductServicesByID, updateProductService } from '../../services/api/ProductAPI';

// interface ServiceProductFormProps {
// 	serviceProduct: ServiceProduct;
// 	open: boolean;
// 	handleClose: () => void;
// 	productNameProvide: 'Airtel' | 'Jio' | 'Vi' | 'Tata';
// 	onSuccess: () => void;
// 	serviceId: string;
// }

// const ServiceProductForm: React.FC<ServiceProductFormProps> = ({
// 	serviceProduct,
// 	open,
// 	handleClose,
// 	productNameProvide,
// 	onSuccess,
// 	serviceId,
// }) => {
// 	const [formData, setFormData] = useState<ServiceProduct>({
// 		_id: '',
// 		productName: productNameProvide,
// 		serviceName: '',
// 		description: '',
// 		isPlanStructure: false,
// 		plans: {},
// 		textContent: { description: '', image: '' },
// 		isFancyNumber: false,
// 		isDTH: false,
// 		status: 0,
// 		createdAt: '',
// 		updatedAt: '',
// 	});
// 	const [image, setImage] = useState<File | null>(null);
// 	const [imagePreview, setImagePreview] = useState<string | null>(null);
// 	const fileInputRef = useRef<HTMLInputElement>(null);
// 	const quillRef = useRef<ReactQuill>(null);
// 	const [loading, setLoading] = useState(false);

// 	useEffect(() => {
// 		if (serviceProduct) {
// 			setFormData({
// 				...serviceProduct,
// 				textContent: {
// 					description: serviceProduct.textContent?.description || '',
// 					image: serviceProduct.textContent?.image || '',
// 				},
// 			});
// 			const fetchData = async () => {
// 				try {
// 					const response = await getSingleProductServicesByID(serviceId);
// 					console.log(response, '=================> fetch datas');
// 				} catch {}
// 			};

// 			fetchData();

// 			if (serviceProduct.textContent?.image) {
// 				if (typeof serviceProduct.textContent.image === 'string') {
// 					setImagePreview(serviceProduct.textContent.image);
// 				} else if (serviceProduct.textContent.image instanceof File) {
// 					setImagePreview(URL.createObjectURL(serviceProduct.textContent.image));
// 				}
// 			}
// 		} else {
// 			const fetchData = async () => {
// 				try {
// 					const response = await getSingleProductServicesByID(serviceId);
// 					console.log(response);
// 				} catch {}
// 			};
// 			fetchData();
// 		}
// 	}, [serviceProduct, productNameProvide]);

// 	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 		const { name, value, type, checked } = e.target;
// 		setFormData({
// 			...formData,
// 			[name]: type === 'checkbox' ? checked : value,
// 		});
// 	};

// 	const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
// 		if (e.target.files && e.target.files[0]) {
// 			const file = e.target.files[0];
// 			setImage(file);
// 			setImagePreview(URL.createObjectURL(file));
// 		}
// 	};

// 	const handleRemoveImage = () => {
// 		setImage(null);
// 		setImagePreview(null);
// 		if (fileInputRef.current) {
// 			fileInputRef.current.value = '';
// 		}
// 	};

// 	const handleQuillChange = (value: string) => {
// 		setFormData({
// 			...formData,
// 			textContent: {
// 				...formData.textContent,
// 				description: value,
// 			},
// 		});
// 	};

// 	const handleSubmit = async (e: React.FormEvent) => {
// 		e.preventDefault();
// 		if (validateForm(formData)) {
// 			try {
// 				setLoading(true);
// 				const formDataObj = new FormData();
// 				formDataObj.append('productName', formData.productName);
// 				formDataObj.append('serviceName', formData.serviceName);
// 				formDataObj.append('description', formData.description);
// 				formDataObj.append('isPlanStructure', String(formData.isPlanStructure));
// 				formDataObj.append('isFancyNumber', String(formData.isFancyNumber));
// 				formDataObj.append('isDTH', String(formData.isDTH));

// 				if (!formData.isPlanStructure) {
// 					formDataObj.append(
// 						'textContent[description]',
// 						formData.textContent.description || ''
// 					);
// 					if (image) {
// 						formDataObj.append('textContentImage', image);
// 					}
// 				}

// 				const response = await updateProductService(formDataObj, formData._id);
// 				if (response.success) {
// 					toast.success(response?.message ? response?.message : 'Successfully updated');
// 					onSuccess();
// 					setTimeout(() => {
// 						handleClose();
// 					}, 3000);
// 				} else {
// 					toast.error(
// 						response?.data?.message ? response?.data?.message : 'Something went wrong'
// 					);
// 				}
// 			} catch (error) {
// 				console.log(error);
// 			} finally {
// 				setLoading(false);
// 			}
// 		}
// 	};

// 	const validateForm = (formData: ServiceProduct): boolean => {
// 		const errors: string[] = [];

// 		if (!formData.serviceName.trim()) {
// 			errors.push('Service Name is required');
// 		}

// 		if (!formData.isPlanStructure) {
// 			if (!formData.textContent.description.trim()) {
// 				errors.push('Text Content Description is required');
// 			}
// 			if (!image && !serviceProduct?.textContent.image) {
// 				errors.push('Image is required');
// 			}
// 		}

// 		if (errors.length > 0) {
// 			errors.forEach((error) => toast.error(error));
// 			return false;
// 		}

// 		return true;
// 	};

// 	const resetForm = () => {
// 		setFormData({
// 			_id: '',
// 			productName: productNameProvide,
// 			serviceName: '',
// 			description: '',
// 			isPlanStructure: false,
// 			plans: {},
// 			textContent: { description: '', image: '' },
// 			isFancyNumber: false,
// 			isDTH: false,
// 			status: 0,
// 			createdAt: '',
// 			updatedAt: '',
// 		});
// 		setImage(null);
// 		setImagePreview(null);
// 	};

// 	const handleCloseDialog = () => {
// 		resetForm();
// 		handleClose();
// 	};

// 	return (
// 		<Dialog open={open}>
// 			<DialogTitle variant="h3" style={{ borderBottom: '1px solid gray' }}>
// 				{`Update ${productNameProvide} Service`}
// 				<IconButton
// 					aria-label="close"
// 					onClick={handleCloseDialog}
// 					sx={{ position: 'absolute', right: 8, top: 8 }}
// 				>
// 					<CloseIcon />
// 				</IconButton>
// 			</DialogTitle>
// 			<DialogContent>
// 				<Container>
// 					<Box sx={{ mt: 0 }}>
// 						<form onSubmit={handleSubmit}>
// 							<TextField
// 								label="Service Name"
// 								name="serviceName"
// 								value={formData.serviceName}
// 								onChange={handleChange}
// 								fullWidth
// 								margin="normal"
// 								size="small"
// 							/>
// 							<TextField
// 								label="Service Description"
// 								name="description"
// 								value={formData.description}
// 								onChange={handleChange}
// 								fullWidth
// 								margin="normal"
// 								size="small"
// 							/>
// 							<FormControlLabel
// 								control={
// 									<Switch
// 										checked={formData.isPlanStructure}
// 										onChange={handleChange}
// 										name="isPlanStructure"
// 									/>
// 								}
// 								label="Is Plan Structure"
// 							/>
// 							{formData.isPlanStructure && (
// 								<>
// 									<FormControlLabel
// 										control={
// 											<Switch
// 												checked={formData.isDTH}
// 												onChange={handleChange}
// 												name="isDTH"
// 											/>
// 										}
// 										label="Is DTH"
// 									/>
// 								</>
// 							)}
// 							{!formData.isPlanStructure && (
// 								<>
// 									<FormControlLabel
// 										control={
// 											<Switch
// 												checked={formData.isFancyNumber}
// 												onChange={handleChange}
// 												name="isFancyNumber"
// 											/>
// 										}
// 										color="secondary"
// 										label="Is Fancy Number"
// 									/>
// 									<Typography style={{ marginTop: '10px' }} color="secondary">
// 										Plan Description:
// 									</Typography>
// 									<ReactQuill
// 										ref={quillRef}
// 										value={formData.textContent.description}
// 										onChange={handleQuillChange}
// 										modules={{
// 											toolbar: [
// 												[{ header: '1' }, { header: '2' }, { font: [] }],
// 												[{ size: [] }],
// 												[
// 													'bold',
// 													'italic',
// 													'underline',
// 													'strike',
// 													'blockquote',
// 												],
// 												[
// 													{ list: 'ordered' },
// 													{ list: 'bullet' },
// 													{ indent: '-1' },
// 													{ indent: '+1' },
// 												],
// 												['link', 'image', 'video'],
// 												['clean'],
// 											],
// 										}}
// 										formats={[
// 											'header',
// 											'font',
// 											'size',
// 											'bold',
// 											'italic',
// 											'underline',
// 											'strike',
// 											'blockquote',
// 											'list',
// 											'bullet',
// 											'indent',
// 											'link',
// 											'image',
// 											'video',
// 										]}
// 									/>
// 									<div style={{ marginTop: '15px' }}>
// 										<input
// 											type="file"
// 											ref={fileInputRef}
// 											onChange={handleImageChange}
// 											style={{ display: 'none' }}
// 										/>
// 										<Button
// 											variant="contained"
// 											component="span"
// 											onClick={() => fileInputRef.current?.click()}
// 										>
// 											Upload Plan Image
// 										</Button>
// 										{imagePreview && (
// 											<div
// 												style={{ position: 'relative', marginTop: '10px' }}
// 											>
// 												<img
// 													src={imagePreview}
// 													alt="Preview"
// 													style={{ width: '100%' }}
// 												/>
// 												<IconButton
// 													aria-label="remove image"
// 													onClick={handleRemoveImage}
// 													sx={{ position: 'absolute', right: 0, top: 0 }}
// 												>
// 													<CloseIcon />
// 												</IconButton>
// 											</div>
// 										)}
// 									</div>
// 								</>
// 							)}

// 							<DialogActions>
// 								<Button
// 									onClick={handleCloseDialog}
// 									color="secondary"
// 									variant="outlined"
// 								>
// 									Cancel
// 								</Button>

// 								<Button
// 									type="submit"
// 									variant="contained"
// 									color="primary"
// 									disabled={loading}
// 								>
// 									{loading ? 'Updating...' : 'Update'}
// 								</Button>
// 							</DialogActions>
// 						</form>
// 					</Box>
// 				</Container>
// 			</DialogContent>
// 		</Dialog>
// 	);
// };

// export default ServiceProductForm;
// ====================================================================================
// ====================================================================================
// ====================================================================================
// ====================================================================================
// ====================================================================================
// ====================================================================================
// ====================================================================================
// ====================================================================================
// ====================================================================================
// ====================================================================================
// ====================================================================================
import React, { useState, useEffect, useRef } from 'react';
import {
	TextField,
	Button,
	Switch,
	FormControlLabel,
	Container,
	Box,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	IconButton,
	Typography,
} from '@mui/material';
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import CloseIcon from '@mui/icons-material/Close';
import { ServiceProduct } from 'types/serviceProduct';
import { getSingleProductServicesByID, updateProductService } from '../../services/api/ProductAPI';
import Preloader from './Preloader';

interface ServiceProductFormProps {
	serviceProduct: ServiceProduct;
	open: boolean;
	handleClose: () => void;
	productNameProvide: 'Airtel' | 'Jio' | 'Vi' | 'Tata';
	onSuccess: () => void;
	serviceId: string;
}

const ServiceProductForm: React.FC<ServiceProductFormProps> = ({
	serviceProduct,
	open,
	handleClose,
	productNameProvide,
	onSuccess,
	serviceId,
}) => {
	const [formData, setFormData] = useState<ServiceProduct>({
		_id: '',
		productName: productNameProvide,
		serviceName: '',
		description: '',
		isPlanStructure: false,
		plans: {},
		textContent: { description: '', image: '' },
		isFancyNumber: false,
		isDTH: false,
		status: 0,
		createdAt: '',
		updatedAt: '',
	});
	const [image, setImage] = useState<File | null>(null);
	const [imagePreview, setImagePreview] = useState<string | null>(null);
	const fileInputRef = useRef<HTMLInputElement>(null);
	const quillRef = useRef<ReactQuill>(null);
	const [loading, setLoading] = useState(false);
	const [preLoaderActive, setPreLoaderActive] = useState(false);
	const [responseStatus, setResponseStatus] = useState(true);
	const [responseStatusMessage, setResponseStatusMessage] = useState('');

	useEffect(() => {
		if (open) {
			const fetchData = async () => {
				setPreLoaderActive(true);
				try {
					const response = await getSingleProductServicesByID(serviceId);
					if (response && response.data) {
						const { data } = response;
						setFormData({
							_id: data._id,
							productName: data.productName,
							serviceName: data.serviceName,
							description: data.description,
							isPlanStructure: data.isPlanStructure,
							plans: data.plans || {},
							textContent: {
								description: data.textContent?.description || '',
								image: data.textContent?.image || '',
							},
							isFancyNumber: data.isFancyNumber,
							isDTH: data.isDTH,
							status: data.status,
							createdAt: data.createdAt,
							updatedAt: data.updatedAt,
						});

						if (data.textContent?.image) {
							if (typeof data.textContent.image === 'string') {
								setImagePreview(data.textContent.image);
							} else if (data.textContent.image instanceof File) {
								setImagePreview(URL.createObjectURL(data.textContent.image));
							}
						}
					}
				} catch (error) {
					setResponseStatus(false);
					setResponseStatusMessage('Failed to fetch service product data');
					console.error('Error fetching data:', error);
				} finally {
					setPreLoaderActive(false);
				}
			};

			fetchData();
		}
	}, [open, serviceId]);

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { name, value, type, checked } = e.target;
		setFormData({
			...formData,
			[name]: type === 'checkbox' ? checked : value,
		});
	};

	const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files && e.target.files[0]) {
			const file = e.target.files[0];
			setImage(file);
			setImagePreview(URL.createObjectURL(file));
		}
	};

	const handleRemoveImage = () => {
		setImage(null);
		setImagePreview(null);
		if (fileInputRef.current) {
			fileInputRef.current.value = '';
		}
	};

	const handleQuillChange = (value: string) => {
		setFormData({
			...formData,
			textContent: {
				...formData.textContent,
				description: value,
			},
		});
	};

	const handleSubmit = async (e: React.FormEvent) => {
		e.preventDefault();
		if (validateForm(formData)) {
			try {
				setLoading(true);
				const formDataObj = new FormData();
				formDataObj.append('productName', formData.productName);
				formDataObj.append('serviceName', formData.serviceName);
				formDataObj.append('description', formData.description);
				formDataObj.append('isPlanStructure', String(formData.isPlanStructure));
				formDataObj.append('isFancyNumber', String(formData.isFancyNumber));
				formDataObj.append('isDTH', String(formData.isDTH));

				if (!formData.isPlanStructure) {
					formDataObj.append(
						'textContent[description]',
						formData.textContent.description || ''
					);
					if (image) {
						formDataObj.append('textContentImage', image);
					}
				}

				const response = await updateProductService(formDataObj, formData._id);
				if (response.success) {
					console.log(response, '=================> response');
					toast.success(response?.message ? response?.message : 'Successfully updated');
					onSuccess();
					setTimeout(() => {
						handleClose();
						setLoading(false);
					}, 3000);
				} else {
					toast.error(
						response?.data?.message ? response?.data?.message : 'Something went wrong'
					);
					setLoading(false);
				}
			} catch (error) {
				console.log(error);
			}
		}
	};

	const validateForm = (formData: ServiceProduct): boolean => {
		const errors: string[] = [];

		if (!formData.serviceName.trim()) {
			errors.push('Service Name is required');
		}

		if (!formData.isPlanStructure) {
			if (!formData.textContent.description.trim()) {
				errors.push('Text Content Description is required');
			}
			if (!image && !serviceProduct?.textContent.image) {
				errors.push('Image is required');
			}
		}

		if (errors.length > 0) {
			errors.forEach((error) => toast.error(error));
			return false;
		}

		return true;
	};

	const resetForm = () => {
		setFormData({
			_id: '',
			productName: productNameProvide,
			serviceName: '',
			description: '',
			isPlanStructure: false,
			plans: {},
			textContent: { description: '', image: '' },
			isFancyNumber: false,
			isDTH: false,
			status: 0,
			createdAt: '',
			updatedAt: '',
		});
		setImage(null);
		setImagePreview(null);
	};

	const handleCloseDialog = () => {
		resetForm();
		handleClose();
	};

	return (
		<Dialog open={open}>
			<DialogTitle variant="h3" style={{ borderBottom: '1px solid gray' }}>
				{`Update ${productNameProvide} Service`}
				<IconButton
					aria-label="close"
					onClick={handleCloseDialog}
					sx={{ position: 'absolute', right: 8, top: 8 }}
				>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				{preLoaderActive && <Preloader />}

				{!preLoaderActive && (
					<Container>
						{responseStatus ? (
							<Box sx={{ mt: 0 }}>
								<form onSubmit={handleSubmit}>
									<TextField
										label="Service Name"
										name="serviceName"
										value={formData.serviceName}
										onChange={handleChange}
										fullWidth
										margin="normal"
										size="small"
									/>
									<TextField
										label="Service Description"
										name="description"
										value={formData.description}
										onChange={handleChange}
										fullWidth
										margin="normal"
										size="small"
									/>
									<FormControlLabel
										control={
											<Switch
												checked={formData.isPlanStructure}
												onChange={handleChange}
												name="isPlanStructure"
											/>
										}
										label="Is Plan Structure"
									/>
									{formData.isPlanStructure && (
										<>
											<FormControlLabel
												control={
													<Switch
														checked={formData.isDTH}
														onChange={handleChange}
														name="isDTH"
													/>
												}
												label="Is DTH"
											/>
										</>
									)}
									{!formData.isPlanStructure && (
										<>
											<FormControlLabel
												control={
													<Switch
														checked={formData.isFancyNumber}
														onChange={handleChange}
														name="isFancyNumber"
													/>
												}
												color="secondary"
												label="Is Fancy Number"
											/>
											<Typography
												style={{ marginTop: '10px' }}
												color="secondary"
											>
												Plan Description:
											</Typography>
											<ReactQuill
												ref={quillRef}
												value={formData.textContent.description}
												onChange={handleQuillChange}
												modules={{
													toolbar: [
														[
															{ header: '1' },
															{ header: '2' },
															{ font: [] },
														],
														[{ size: [] }],
														[
															'bold',
															'italic',
															'underline',
															'strike',
															'blockquote',
														],
														[
															{ list: 'ordered' },
															{ list: 'bullet' },
															{ indent: '-1' },
															{ indent: '+1' },
														],
														['link', 'image', 'video'],
														['clean'],
													],
												}}
												formats={[
													'header',
													'font',
													'size',
													'bold',
													'italic',
													'underline',
													'strike',
													'blockquote',
													'list',
													'bullet',
													'indent',
													'link',
													'image',
													'video',
												]}
											/>
											<div style={{ marginTop: '15px' }}>
												<input
													type="file"
													ref={fileInputRef}
													onChange={handleImageChange}
													style={{ display: 'none' }}
												/>
												<Button
													variant="contained"
													component="span"
													onClick={() => fileInputRef.current?.click()}
												>
													Upload Plan Image
												</Button>
												{imagePreview && (
													<div
														style={{
															position: 'relative',
															marginTop: '10px',
															display: 'flex',
															justifyContent: 'center',
															marginBottom: '10px',
															border: '1px solid #ccc',
															padding: '10px',
															borderRadius: '8px',
															backgroundColor: '#f9f9f9',
														}}
													>
														<img
															src={imagePreview}
															alt="Preview"
															style={{
																width: 'auto',
																height: '300px',
															}}
														/>
														<IconButton
															aria-label="remove image"
															onClick={handleRemoveImage}
															sx={{
																position: 'absolute',
																right: 0,
																top: 0,
															}}
														>
															<CloseIcon />
														</IconButton>
													</div>
												)}
											</div>
										</>
									)}

									<DialogActions>
										<Button
											onClick={handleCloseDialog}
											color="secondary"
											variant="outlined"
										>
											Cancel
										</Button>

										{loading ? (
											<Button
												type="submit"
												variant="contained"
												color="primary"
												disabled={true}
											>
												Sending...
											</Button>
										) : (
											<Button
												type="submit"
												variant="contained"
												color="primary"
												disabled={loading}
											>
												{loading ? 'Updating...' : 'Update'}
											</Button>
										)}
									</DialogActions>
								</form>
							</Box>
						) : (
							<Box sx={{ mt: 0 }}>
								<Typography
									variant="h6"
									sx={{ mt: 2, textAlign: 'center', color: 'red' }}
								>
									{responseStatusMessage}
								</Typography>
							</Box>
						)}
					</Container>
				)}
			</DialogContent>
		</Dialog>
	);
};

export default ServiceProductForm;
